module.exports = __webpack_public_path__ + "img/4_newYouth_flc.311400a2.png";